import React from 'react'
import {component_tool, framework_tool} from "@/tool";

const {modelUtils} = framework_tool;
const {WizBrowserExport, WizButton, WizModal} = component_tool

export const mapStateToProps = ({nameSpace, method}, state, ownProps) => {
  const list = modelUtils.getModelEntity(state[nameSpace], `${nameSpace}@${method}`);
  const headList = list.data && list.data.headList
  return {
    dynamicColumns: Array.isArray(headList) && headList.length ? headList : []
  }
};

export const handleExport = ({title, column, columnsType}, nextProps, nextState, key) => {
  let result = false;
  if (columnsType && columnsType) {
    result = true;
  }
  const res = nextProps[key]
  const {success, data = {}, msg} = res
  const {dataList = [], headList = []} = data
  if (success) {
    const rows = dataList.map(val => {
      for (const item in val) {
        if (item.includes('Rate')) {
          if (val[item] != null && val[item] != '/') {
            val[item] = item.includes('Rate') ? val[item] + '%' : val[item]
          }
        }
        if (item.includes('accountState') && val[item] !== undefined && val[item] !== null) {
          val[item] = val[item] == 1 ? '激活' : '禁用'
        }
        if (item.includes('jobState') && val[item] !== undefined && val[item] !== null) {
          val[item] = val[item] === 1 ? '在职' : val[item] === 0 ? '离职' : val[item]
        }
        if (item.includes('_result') && (val[item] === undefined || val[item] === null || val[item] === '')) {
          val[item] = '/'
        }
        if (item.includes('_pass') && (val[item] === undefined || val[item] === null || val[item] === '')) {
          val[item] = '/'
        }
      }
      return val
    })
    let headList_ = [];
    if (headList && headList.length) {
      headList.forEach(val => {
        const {name, list} = val;
        if (list && list.length) {
          let list_new = [];
          list.forEach(val_ => {
            if (val_) {
              if (!result || (result && val_ && val_.name && (val_.name === '完成状态' || val_.name === '完成时间' || val_.name === '通过人数' || val_.name === '阶段完成率'))) {
                list_new.push(val_);
              }
            }
            val.list = list_new;
          })
        }
        headList_.push(val);
      })
    }
    const _columns = headList_.map(val => ({
      headerName: val.name,
      field: val.key,
      children: val.list && val.list.length ? val.list.map(val => ({
        headerName: val.name,
        field: val.key
      })) : undefined
    }))
    log.info('headList_',headList_);
    log.info('rows',rows);
    WizBrowserExport({
      title,
      sheetName: title,
      columns: column.filter((_, index) => index).concat(_columns),
      rows,
      filename: title + '.xlsx',
    })
    return true
  } else {
    wizNotice.error(msg)
    return false;
  }
}
